var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teacherLayoutRootBox" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("数据统计")]),
      _vm._v(" "),
      _c("div", [_c("m-selects", { on: { change: _vm.selectChange } })], 1)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c("div", { attrs: { role: "aphorism" } }, [_c("m-aphorism")], 1),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { role: "openingStatus" } },
        [
          _c("m-opening-status", {
            attrs: {
              "left-list": _vm.openingStatus,
              ranking: _vm.ranking,
              "hide-right": true
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "", role: "learningDuration" } },
        [
          _c("m-title", {
            attrs: {
              "title-text": "课件学习",
              "tip-text": _vm.tipText + "，显示从当前时间往前一周或一个月的数据"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "learningDuration" },
            [
              _c("m-chart", {
                attrs: {
                  "option-data": _vm.learningDurationBrokenLineData,
                  "tip-style": _vm.tipStyle
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "timeSwitchBox" },
            [_c("m-switch", { on: { change: _vm.timeSwitchChange } })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "笔记和讨论", role: "notesAndDiscussions" } },
        [
          _c(
            "div",
            { staticStyle: { height: "55%", width: "80%" } },
            [
              _c("m-notes-and-discussions", {
                attrs: { "data-list": _vm.notesAndDiscusCounts }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "测验平均分", role: "testProgress" } },
        [
          _c(
            "div",
            { staticClass: "cProgressBox" },
            [_c("m-circular-progress", { attrs: { score: _vm.testScore } })],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-title": "", role: "testScore" } },
        [
          _c("m-title", {
            attrs: { "title-text": "测验分数", "tip-text": _vm.testTipText }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "learningDuration" },
            [
              _c("m-chart", {
                attrs: { "option-data": _vm.testScoreBrokenLineData }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9864a1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9864a1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/layout/studentLayout.vue
// module id = null
// module chunks = 